import React, { useContext, useEffect, useRef, useState } from 'react'
import globalStyles from "../../Styles/global.module.scss"
import styles from "../../Styles/ComponentStyles/MainPages/Profile.module.scss"
import memberUserStyles from "../../Styles/ComponentStyles/MainPages/Member.module.scss"

import Grid from '@mui/material/Grid2';
import { DataGrid } from '@mui/x-data-grid';
import AddIcon from '@mui/icons-material/Add';
import Icons from '../../Utils/Layout/Icons/Icons';
import deleteIcon from "../../Assets/Member/Delete-Icons.svg"
import { Avatar, Box, CircularProgress, IconButton, Menu, MenuItem, Typography } from '@mui/material';

import GlobalTextfield from '../../Utils/Layout/GlobalTextfield/GlobalTextfield';
import GlobalSymbols from '../../Utils/Layout/GlobalSymbols/GlobalSymbols';
import GlobalAutocomplate from '../../Utils/Layout/GlobalAutocomplate/GlobalAutoComplate';
import GlobalButton from '../../Utils/Layout/GlobalButton/GlobalButton';
import GlobalDialog from '../../Utils/Layout/GlobalDialog/GlobalDialog';
import useStateOptions from '../../Utils/Hooks/useStateOptions';
import { capitalize, useIsBelow1200 } from '../../Utils/Constant/Constant';
import { useSnackbar } from '../../Utils/Layout/GlobalSnackbar/GlobalSnackbar';

// DIALOG
import ProfileNewMemberDialog from './ProfileDialogs/ProfileNewMemberDialog';
import GlobalWarningDialog from '../../Utils/Layout/GlobalWarningDialog/GlobalWarningDialog';

// CONTEXT
import { GlobalUserContext, GlobalUserContextPayload } from '../../Context/GlobalUserDetailContext';
import { StateOptionsInterface } from '../../models/axiosModels';
import { DashboardContext, DashboardDetailPayload } from '../../Context/DashboardDetailContext';
import { deleteResourceFileInterface, UserProfileDetailsPayloadModel } from '../../models/dashboardAxiosModels';
import agent from '../../Services/api';
import AppNavbar from '../../Components/AppNavbar/AppNavbar';


const ProfileHome = () => {

    const {
        setFlagLoader,
        setUserProfileDetails,
        userProfileDetails,

        profileTeamDetails,
        setProfileTeamDetails,

        storedProfileUserUploadId
    } = useContext(GlobalUserContext) as GlobalUserContextPayload

    const { userDetails, setUserDetails } = useContext(DashboardContext) as DashboardDetailPayload
    const { showSnackbar } = useSnackbar();
    const { stateOptions, getStateOptions } = useStateOptions()

    const isProfileAdmin = userProfileDetails?.user?.flagAdmin

    const [selectedUserId, setSelectedUserId] = useState<any | "">("");
    const [dialogTitleName, setDialogTitleName] = useState("New Member");
    const [errors, setErrors] = useState({
        firstName: "",
        lastName: "",
        agencyName: "",
        contact: "",
        stateID: "",
    });
    const [profileMemberPayloadDetails, setProfileMemberPayloadDetails] = useState<any>(null)
    const [flagOpenNewMemberDialog, setFlagOpenNewMemberDialog] = useState(false)

    useEffect(() => {
        getStateOptions()
        getUserDetails()
        // initializeAcrylicTeamListAuth()
    }, [])



    const initializeAcrylicTeamListAuth = async (userId: number | null = null) => {

        let payloadQuery = "";
        if (isProfileAdmin) {
            // Admin: always pass flagGetAll=false and userId
            payloadQuery = `flagGetAll=false&assignedToUserId=${userId ?? userProfileDetails?.user?.userId}`;
        } else {
            // Non-admin: pass only assignedToUserId
            payloadQuery = `assignedToUserId=${userId ?? userProfileDetails?.user?.userId}`;
        }

        setFlagLoader(true);
        const response = await agent.getAcrylicTeamMemberDashboardApi.get(payloadQuery);
        console.log("response of getAcrylicTeamMemberApi", response);
        if (response?.status && response?.data) {
            setProfileTeamDetails(response.data);
            setFlagLoader(false);
        }
        else {
            const errorMessage = response?.data?.error?.message || 'Something Went Wrong!';
            showSnackbar(errorMessage, 'error');
            setFlagLoader(false);
        }
    };

    const getUserDetails = async () => {
        try {
            setFlagLoader(true)
            const response = await agent.getUserProfileDetailsAPI.get()
            if (response?.status) {
                setUserDetails(response?.data?.user)
                setUserProfileDetails({
                    ...userProfileDetails,
                    user: {
                        ...userProfileDetails.user,
                        profileImage: response?.data?.user?.profileImage
                    }
                });
                setFlagLoader(false)
            } else {
                const err = response?.error?.message ? response?.error?.message : "Error fetching user details 1";
                showSnackbar(err, 'error')
                setFlagLoader(false)
            }
        } catch (error) {
            showSnackbar("Something Went Wrong", 'error')
        }
    }

    const validateForm = () => {
        const newErrors: any = {};
        const nameRegex = /^[a-zA-Z\s]+$/;
        const phoneRegex = /^\d{7,15}$/;

        if (!userDetails?.firstName?.trim()) {
            newErrors.firstName = "First name is required.";
        } else if (!nameRegex.test(userDetails.firstName)) {
            newErrors.firstName = "First name can only contain letters.";
        }

        if (!userDetails?.lastName?.trim()) {
            newErrors.lastName = "Last name is required.";
        } else if (!nameRegex.test(userDetails.lastName)) {
            newErrors.lastName = "Last name can only contain letters.";
        }

        if (!userDetails?.agencyName?.trim()) {
            newErrors.agencyName = "Agency name is required.";
        }

        if (!userDetails?.contact?.trim()) {
            newErrors.contact = "Phone number is required.";
        } else if (!phoneRegex.test(userDetails.contact)) {
            newErrors.contact = "Invalid phone number format.";
        }

        if (!userDetails?.stateID) {
            newErrors.stateID = "Please select a valid state.";
        }

        return newErrors;
    };

    const handleBlur = (field: string) => {
        const newErrors = validateForm();
        setErrors({
            ...errors,
            [field]: newErrors[field] || "",
        });
    };

    const handleUpdateUserProfileDetails = async (overrideUploadId?: number | null, skipValidation: boolean = false) => {

        if (!skipValidation) {
            const newErrors = validateForm();
            setErrors(newErrors);

            if (Object.values(newErrors).some((error) => error !== "")) {
                return;
            }
        }

        try {
            setFlagLoader(true)
            const payload: UserProfileDetailsPayloadModel = {
                firstName: userDetails?.firstName,
                lastName: userDetails?.lastName,
                agencyName: userDetails?.agencyName,
                contact: userDetails?.contact,
                addressLine1: userDetails?.addressLine1 ? userDetails?.addressLine1 : "",
                addressLine2: userDetails?.addressLine2 ? userDetails?.addressLine2 : "",
                city: userDetails?.city ? userDetails?.city : "",
                zipcode: userDetails?.zipcode ? userDetails?.zipcode : "",
                stateID: userDetails?.stateID ? userDetails?.stateID : "",
                profileImage: storedProfileUserUploadId ?? 0,
            }

            const response = await agent.userProfileDetailsUpdateAPI.put(payload)
            if (response?.status) {
                setUserDetails(response?.data?.user)
                setFlagLoader(false)
                showSnackbar("Details updated successfully", 'success')
                getUserDetails()
            }
            else {
                const err = response?.message || response?.data?.error?.message || "Error updating user details.";
                showSnackbar(err, 'error')
                setFlagLoader(false)
            }
        }
        catch (error) {
            showSnackbar("Something Went Wrong", 'error')
        }
    }

    const handleClose = (event: any, reason: any) => {
        if (reason && reason == "backdropClick") {
            return;
        }
        setFlagOpenNewMemberDialog(false)
    }


    return (
        <>
            {flagOpenNewMemberDialog &&
                <GlobalDialog
                    flagHeadSection={true}
                    maxWidth="md"
                    dialogHead={dialogTitleName}
                    open={flagOpenNewMemberDialog}
                    view={
                        <ProfileNewMemberDialog
                            flagOpenNewMemberDialog={flagOpenNewMemberDialog}
                            setFlagOpenNewMemberDialog={setFlagOpenNewMemberDialog}

                            profileMemberPayloadDetails={profileMemberPayloadDetails}
                            setProfileMemberPayloadDetails={setProfileMemberPayloadDetails}

                            selectedUserId={selectedUserId}
                            initializeAcrylicTeamListAuth={initializeAcrylicTeamListAuth}

                            isEditMode={!!profileMemberPayloadDetails?.teamId}
                        />
                    }
                    onClose={handleClose}
                />
            }

            <Grid container>
                <Grid size={{ xs: 12 }}>
                    <Grid container>
                        <Grid size={{ xs: 12 }} className={`${styles.profileWrapperItem}`}>
                            <Grid container>
                                <Grid size={{ xs: 12 }} sx={{ margin: "30px 0px 25px" }}>
                                    <Grid container sx={{ columnGap: "25px", rowGap: "25px" }}>
                                        <Grid className={`${styles.gblProfileTextfieldItem}`}>
                                            <Grid container>
                                                <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        User Name <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <GlobalTextfield
                                                        autoComplete='off'
                                                        placeholder='Enter User Name'
                                                        size='medium'
                                                        fullWidth
                                                        disabled={true}
                                                        value={userDetails?.username}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.gblProfileTextfieldItem}`}>
                                            <Grid container>
                                                <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Email Address <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <GlobalTextfield
                                                        autoComplete='off'
                                                        placeholder='Enter Email Address'
                                                        size='medium'
                                                        fullWidth
                                                        disabled={true}
                                                        value={userDetails?.email}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.gblProfileTextfieldItem}`}>
                                            <Grid container>
                                                <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        First Name <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <GlobalTextfield
                                                        autoComplete='off'
                                                        placeholder='Enter First Name'
                                                        size='medium'
                                                        fullWidth
                                                        onBlur={() => handleBlur("firstName")}
                                                        error={Boolean(errors.firstName)}
                                                        helperText={errors.firstName}
                                                        value={userDetails?.firstName}
                                                        onChange={(e) => {
                                                            const input = e.target.value;
                                                            const onlyLetters = input.replace(/[^a-zA-Z\s]/g, "");
                                                            setUserDetails({ ...userDetails, firstName: onlyLetters });
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.gblProfileTextfieldItem}`}>
                                            <Grid container>
                                                <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Last Name <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <GlobalTextfield
                                                        autoComplete='off'
                                                        placeholder='Enter Last Name'
                                                        size='medium'
                                                        fullWidth
                                                        onBlur={() => handleBlur("lastName")}
                                                        error={Boolean(errors.lastName)}
                                                        helperText={errors.lastName}
                                                        value={userDetails?.lastName}
                                                        onChange={(e) => {
                                                            const input = e.target.value;
                                                            const onlyLetters = input.replace(/[^a-zA-Z\s]/g, "");
                                                            setUserDetails({ ...userDetails, lastName: onlyLetters });
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.gblProfileTextfieldItem}`}>
                                            <Grid container>
                                                <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Agency Name <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <GlobalTextfield
                                                        autoComplete='off'
                                                        placeholder='Enter Agency Name'
                                                        size='medium'
                                                        fullWidth
                                                        onBlur={() => handleBlur("agencyName")}
                                                        error={Boolean(errors.agencyName)}
                                                        helperText={errors.agencyName}
                                                        value={userDetails?.agencyName}
                                                        onChange={(e) => {
                                                            setUserDetails({ ...userDetails, agencyName: e.target.value })
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.gblProfileTextfieldItem}`}>
                                            <Grid container>
                                                <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Phone Number <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <GlobalTextfield
                                                        autoComplete='off'
                                                        placeholder='Enter Phone Number'
                                                        size='medium'
                                                        fullWidth
                                                        onBlur={() => handleBlur("contact")}
                                                        error={Boolean(errors.contact)}
                                                        helperText={errors.contact}
                                                        value={userDetails?.contact}
                                                        onChange={(e) => {
                                                            const numericValue = e.target.value.replace(/\D/g, "");
                                                            setUserDetails({ ...userDetails, contact: numericValue });
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.gblProfileTextfieldItem}`}>
                                            <Grid container>
                                                <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Address Line 1
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <GlobalTextfield
                                                        autoComplete='off'
                                                        placeholder='Enter Adresss'
                                                        size='medium'
                                                        fullWidth
                                                        value={userDetails?.addressLine1}
                                                        onChange={(e) => {
                                                            setUserDetails({ ...userDetails, addressLine1: e.target.value })
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.gblProfileTextfieldItem}`}>
                                            <Grid container>
                                                <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Address Line 2
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <GlobalTextfield
                                                        autoComplete='off'
                                                        placeholder='Enter Adresss'
                                                        size='medium'
                                                        fullWidth
                                                        value={userDetails?.addressLine2}
                                                        onChange={(e) => {
                                                            setUserDetails({ ...userDetails, addressLine2: e.target.value })
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.gblProfileTextfieldItem}`}>
                                            <Grid container>
                                                <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Zipcode
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <GlobalTextfield
                                                        autoComplete='off'
                                                        placeholder='Enter Zipcode'
                                                        size='medium'
                                                        fullWidth
                                                        value={userDetails?.zipcode}
                                                        onChange={(e) => {
                                                            setUserDetails({ ...userDetails, zipcode: e.target.value })
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.gblProfileTextfieldItem}`}>
                                            <Grid container>
                                                <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        City
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <GlobalTextfield
                                                        autoComplete='off'
                                                        placeholder='Enter City'
                                                        size='medium'
                                                        fullWidth
                                                        value={userDetails?.city}
                                                        onChange={(e) => {
                                                            setUserDetails({ ...userDetails, city: e.target.value })
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>

                                        <Grid className={`${styles.gblProfileTextfieldItem}`}>
                                            <Grid container>
                                                <Grid size={12} className={`${globalStyles.gblFieldSpcaing}`}>
                                                    <Typography component={'span'} className={`${globalStyles.gblCWhite} ${globalStyles.globalTextV15}`}>
                                                        Select State  <GlobalSymbols symbol={"astric"} />
                                                    </Typography>
                                                </Grid>
                                                <Grid size={12}>
                                                    <GlobalAutocomplate
                                                        placeholder='Enter Agency Name'
                                                        size='small'
                                                        fullWidth
                                                        onBlur={() => handleBlur("stateID")}
                                                        error={Boolean(errors.stateID)}
                                                        helperText={errors.stateID}
                                                        options={stateOptions}
                                                        getOptionLabel={(options: StateOptionsInterface) => options.state_name}
                                                        value={stateOptions?.find(option => option.state_id == userDetails?.stateID) || null}
                                                        onChange={(e: any, newValue: any) => {
                                                            setUserDetails({ ...userDetails, stateID: newValue ? newValue.state_id : null })
                                                        }}
                                                    />
                                                </Grid>
                                            </Grid>
                                        </Grid>
                                    </Grid>
                                </Grid>

                                <Grid size={{ xs: 12 }}>
                                    <GlobalButton
                                        value='Update Profile'
                                        variant='contained'
                                        size='large'
                                        className={`${styles.updateProfileBtn}`}
                                        onClick={() => handleUpdateUserProfileDetails()}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>
        </>
    )
}

export default ProfileHome